<ion-header class="privateHeader-wrapper ion-no-border">
  <ion-toolbar>
    <ion-row>
      <ion-col class="privateHeader-menuLogo">
        <a
          href="https://www.mapfreglobalrisks.com/"
          target="_blank"
          rel="noopener noreferrer"
          class="privateHeader-menuLogo__logo"
        >
          <img
            src="../../../assets/images/LogoMAPFREGR_new.svg"
            alt="Icono"
          />
        </a>
      </ion-col>

      <ion-col class="privateHeader-userInfo p-0">
        <a
        href="https://www.mapfreglobalrisks.com/"
        target="_blank"
        rel="noopener noreferrer"
        class="privateHeader-menuLogo__logo privateHeader-menuLogo__logo-myGlobal"
        >
          <img
            src="../../../assets/images/MyGlobalRiskRGB_Positivo_new.svg"
            alt="Icono"
          />
        </a>
        <ion-item
          popoverWidth
          lines="none"
          class="ion-no-padding lenguage-selector"
        >
          <span class="icon icon-SMALL-ARROW-DOWN"></span>
          <ion-select
            class="ml-0"
            [value]="lang"
            interface="popover"
            slot="end"
            mode="md"
            (ionChange)="changeLanguage($event)"
          >
            @if('header.es' | translate) {
            <ion-select-option value="es">{{
              'header.es' | translate
            }}</ion-select-option>
            <ion-select-option value="en">{{
              'header.en' | translate
            }}</ion-select-option>
            <ion-select-option value="pt">{{
              'header.pt' | translate
            }}</ion-select-option>
            }
          </ion-select>
        </ion-item>

        <ion-item lines="none" class="privateHeader-userInfo__icons">
          <ion-label class="close-sesion" (click)="logOut()" style="cursor: pointer;">
            <span>{{ 'logged-header.close-sesion' | translate }}</span>
          </ion-label>
          <ion-label>
            <a (click)="logOut()" class="icon icon-LOG-OUT"></a>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-toolbar>

  <div class="d-flex ml-15 justify-content-between align-items-center w-100">
    <ion-item
      class="privateHeader-menuLogo__items ion-no-padding"
      lines="none"
      placement="start"
    >
      @if(checkRol('my-global')) {
      <ion-label class="privateHeader-menuLogo__items__item" [ngClass]="{'active' : tabSelected === 'my-global'}">
        <a
          (click)="handleRedirect('my-global')"
          class="privateHeader-menuLogo__items__item__link logo-styled"
          [innerHTML]="'header.title' | translate"
          ></a
        >
      </ion-label>
      } @if(checkRol('content')) {
      <ion-label class="privateHeader-menuLogo__items__item" [ngClass]="{'active' : tabSelected === 'content'}">
        <a
          (click)="handleRedirect('content')"
          class="privateHeader-menuLogo__items__item__link"
          >{{ 'logged-header.content' | translate }}</a
        >
      </ion-label>
      } @if(checkRol('management')) {
      <ion-label class="privateHeader-menuLogo__items__item" [ngClass]="{'active' : tabSelected === 'management'}">
        <a
          (click)="handleRedirect('management')"
          class="privateHeader-menuLogo__items__item__link"
          >{{ 'logged-header.management' | translate }}</a
        >
      </ion-label>
      }
    </ion-item>
    <ion-item class="download-icon-container" lines="none">
      @if(isDownloading) {
        <ion-spinner name="bubbles" color="danger"></ion-spinner>
      } @else if(showButtonDownload) {
        <span class="icon-wrapper" title="PDF">
          <ion-icon class="icon icon-DESCARGA-DOCUMENTOS" (click)="handleDownload()"></ion-icon>
        </span>
      }
    </ion-item>
  </div>
</ion-header>
